import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { format } from 'date-fns';

const initialState = {
    loading: false,
    log: [],
    res: null,
    cdnSync: {},
    aiTranscodings: {}
};

const cdnSyncUpdate = (state, type, value) => {
    const cdnSync = { ...state.cdnSync };
    cdnSync[type] = value;
    return updateObject( state, {  cdnSync: cdnSync } );
}

const reducer = ( state = initialState, action) => {
    // defined for use in ai transaction section
    let ai;
    
    switch (action.type) {
		case actionTypes.CDN_LOG_GET_START:
            return updateObject(state, { loading: true });
        case actionTypes.CDN_LOG_GET_SUCCESS:
            // from Günther
            /*action.res.content.split('#').forEach(entry=>{ 
                console.info(new Date(e[0] * 1000).toLocaleString("de-DE") ,e[1]); 
            });*/
            
            const data = (action.res.content && action.res.content.split('#')) || [];
            const log = data.map(entry => {
                return entry.split(';');
            });

            return updateObject(state, { loading: false, res: action.res, log: log.reverse() });
		case actionTypes.CDN_LOG_GET_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.CDN_LOG_RESET:
            return updateObject(state, { loading: false, res: null, log: [] });
        case actionTypes.CDN_SYNC_START: return cdnSyncUpdate(state, action.distType, true);
        case actionTypes.CDN_SYNC_SUCCESS: return cdnSyncUpdate(state, action.distType, false);
        case actionTypes.CDN_SYNC_FAIL: return cdnSyncUpdate(state, action.distType, false);
        case actionTypes.AI_TRANSCODING_START:
            ai = { ...state.aiTranscodings };
            ai[action.id] = {};
            return updateObject(state, { aiTranscodings: ai });
        case actionTypes.AI_TRANSCODING_UPDATE: 
            ai = { ...state.aiTranscodings };
            ai[action.id].interval = action.interval;
            ai[action.id].processId = action.processId;
            return updateObject(state, { aiTranscodings: ai });
        case actionTypes.AI_TRANSCODING_SUCCESS:
            ai = { ...state.aiTranscodings };
            delete ai[action.id];
            return updateObject(state, { aiTranscodings: ai });
        case actionTypes.AI_TRANSCODING_FAIL: 
            ai = { ...state.aiTranscodings };
            delete ai[action.id];
            return updateObject(state, { aiTranscodings: ai });
        default: 
            return state;
    }
}

export default reducer;
